import "#/legacy/jquery-global.js";
import "#vendor/jquery_ujs.js";
import "./shared/codeload.js";
import "./shared/client/jst.js";
import "select2";
import "#vendor/jquery.caret.js";
import "underscore";
import "./shared/jquery_ui_sortable.js";
import "jquery-ui/ui/effect";
import "jquery-ui/ui/effects/effect-highlight";
import "handlebars";
import "quill";
import "sweetalert";
import "#vendor/sweet-alert-confirm.js";
import "#lib/client_exception_notifier.js";
import "#vendor/cocoon.js";
import.meta.glob("./shared/behaviours/*.{js,hbs,jst.ejs}", { eager: true });
import.meta.glob("./shared/components/*.{js,hbs,jst.ejs}", { eager: true });
import.meta.glob("./admin/behaviours/*.js", { eager: true });
import "./shared/utilities/contrast_detection.js";
import "./shared/utilities/get_url_param.js";
import "./admin/base.js";
import "./admin/dashboard.js";
import "./admin/jsdiff.js";
import "./admin/form.js";
import "./admin/controllers/admin_header.js";
import "./admin/controllers/settings_navigation.js";
import "./admin/controllers/definition_list.js";
import "./admin/controllers/sessions_fieldset.js";
import "./admin/components/content_events_list.js";
import "./admin/components/admin_search.js";
import "./admin/components/index_table_manager.js";
import "./admin/components/textarea_expander.js";
import "./admin/components/copy_button.js";
import "./admin/components/bulk_label_modal.js";
import "./admin/components/bulk_review_modal.js";
import "./admin/components/relative_time.js";
import "./admin/components/label_applier.js";
import "./admin/components/label_creator.js";
import "./admin/components/label_list.js";
import "./admin/components/label_selector.js";
import "./admin/components/schedule_form.js";
import "./admin/components/layout_selector.js";
import "./admin/components/list-summarizer.js";
import "./admin/components/dropdown_menu.js";
import "./admin/components/publishing_controls.js";
import "./admin/components/reports.js";
import "./admin/components/bulk_action_toolbar.js";
import "./admin/components/seo_fields_manager.js";
import "./admin/components/resource_storage.js";
import "./admin/components/spinner.js";
import "./admin/components/form_field_inheritance_chain.js";
import "./admin/components/spotlight.js";
import "./admin/components/spotlight_search.js";
import "./admin/components/publishing_snippet_preview.js";
import "./admin/components/appointment_outcome_tool.js";
import "./admin/components/loading_indicator.js";
import "./admin/components/message_composer.js";
import "./admin/components/patient_email_messages/form.js";
import "./admin/components/patient_text_messages/form.js";
import "./admin/components/patient_journey_tasks/prepare_modal_form.js";
import "./admin/components/responsive_preview.js";
import "./admin/components/messages_inbox.js";
import "./admin/components/wysiwyg.js";
import "./admin/data_behavior.js";
import "./admin/current_edit.js";
import "./admin/call_center/index.js";
import "./admin/sidebar.js";
import "./tribute.js";

// Eagerly imported so the globals they define are available to inline scripts on edit pages.
import "./admin/singleton/experiment_modals.js";
import "./admin/singleton/preview_thumbnail.js";
import "./admin/singleton/versions/compare.js";
import "./admin/page_builder.js";
import "./admin/assessment_builder/index.js";
import "./admin/patient_journey_manager/patient_documents/index.js";
import "./assessment_viewer/index.js";
